var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoconut = function SvgCoconut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coconut_svg__a)",
    d: "M149.37 56.811S142.028 54 138.37 54c-5.53.12-11.039.732-16.462 1.828-9.146 1.827-21.493 11.422-26.98 16.905S72.063 97.406 69.32 102.889s-9.146 24.673-8.23 36.552c.914 11.879 3.657 35.639 18.29 49.346s28.352 25.586 45.729 26.5 43.137 2.385 54.036-6.118S149.37 56.811 149.37 56.811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coconut_svg__b)",
    d: "M138.078 54.03c-5.948-.462-18.3 4.61-23.793 10.141-5.493 5.532-15.557 19.363-19.218 35.959s-5.49 31.349-2.745 44.257 10.981 24.9 17.387 30.427 17.388 17.518 21.048 21.207 6.406 5.532 8.236 8.3 10.982 6.454 14.642 6.454 7.779 3.227 11.439 3.227 13.727-3.688 17.387-5.532 11.9-10.142 13.727-12.908 2.746-5.533 4.576-6.455 1.83-5.213 1.83-6.294 2.746-1.945 3.661-2.9 1.83-6.484 1.83-8.328.915-11.064.915-14.752c0 0 0-11.987-.915-14.753a50.8 50.8 0 0 1-1.83-13.07c0-4.448-5.491-11.824-6.406-16.434s-4.129-10.015-6.64-13.306-7.087-6.979-8.917-10.667-6.406-8.3-9.152-11.986c-3.14-3.876-6.5-7.569-10.063-11.06-1.833-1.849-12.764-9.085-15.077-9.616a71.7 71.7 0 0 0-11.922-1.912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coconut_svg__c)",
    d: "M144.561 60.313c-10.5-1.241-20.62 1.108-26.9 8.862s-15.689 24.592-17.482 35.67-1.345 28.137 0 35.005 2.689 17.281 5.379 21.49 10.31 11.743 12.776 14.18 4.93 6.484 6.948 8.116 10.086 8.205 11.879 10.273 6.425 7.828 8.293 8.492 5.9 1.4 7.994 2.142S159.221 208 164.787 208s15.77-2.751 18.553-5.5 7.923-6 8.6-8.5 3.46-1.587 4.388-3.421 2.783-8.252 2.783-11 4.638-1.834 5.566-4.585 2.319-13.3 2.319-18.8 0-13.755-.928-16.506-2.783-3.668-2.783-4.585 0-11.921-2.783-15.588-5.566-15.589-10.2-19.257-4.638-4.585-6.494-7.336a157 157 0 0 0-10.2-12.837c-1.855-1.834-12.212-11.7-13.239-13.087-2.535-3.422-12.382-6.28-15.808-6.685"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coconut_svg__d)",
    d: "M161.034 85.712c-4.708-3.809-13-6.274-16.591-5.6s-15.694 8.515-17.488 11.428-.224 4.706-1.793 6.947-4.036 6.274-4.709 8.739a40 40 0 0 0-1.27 8.589c0 2.241.747 7.021 0 8.963s1.046 4.183.9 5.378-.748 3.137-.15 4.93-.9 3.735-.149 4.93 1.5 3.734.448 5.676 3.438 2.689 4.335 4.034 3.587 7.768 5.53 10.307 13.9 15.536 15.545 16.881 3.886 4.332 5.306 4.855 4.148-.374 7.062.747 9.865 2.016 12.107 1.12 13.042-7.469 14.387-10.158 10.164-18.374 8.221-28.383-2.691-22.408-4.634-25.844-9.865-19.121-13.452-21.362-13.605-12.177-13.605-12.177"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coconut_svg__a",
    x1: 61.001,
    x2: 181.001,
    y1: 135,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coconut_svg__b",
    x1: 91,
    x2: 209,
    y1: 134.001,
    y2: 134.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coconut_svg__c",
    x1: 98.997,
    x2: 206.996,
    y1: 134,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FB4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coconut_svg__d",
    x1: 119,
    x2: 193.004,
    y1: 132.002,
    y2: 132.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCEDF4"
  })))));
};
export default SvgCoconut;